export const companyTypes = [
  { label: 'CD', value: 'CD' },
  { label: 'Escritório', value: 'Escritório' },
  { label: 'Fábrica', value: 'Fábrica' },
  { label: 'Armazém Externo', value: 'Armazém Externo' },
];
